/**
 * 회사 기본정보 컬럼 정의
 * COM_BASIC 화면 전용
 */

import dayjs from 'dayjs';
import { CreateColumn } from '../../../../Services/agGrid/createColumn';

/**
 * 회사정보 그리드 컬럼 정의
 * @param {object} props - 컴포넌트 props (gridRef1, rowData, selectedRowNosRef 등)
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    CreateColumn('no', 'NO', 'center', 75, false, false, false, 'checkbox', {
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow,
        gridRef: props.gridRef1,
        rowData: props.rowData,
        selectedRowNosRef: props.selectedRowNosRef,
        lastCheckedIndexRef: props.lastCheckedIndexRef,
        handleRowSelection: props.handleRowSelection,
        dispatchGrid: props.dispatchGrid,
        gridState: props.gridState,
      },
      maxWidth: 75,
      cellClass: 'delete-action-cell',
    }),
    CreateColumn('coNm', '회사명', 'left', 200, false, false, false, 'text', {
      minWidth: 200,
    }),
    CreateColumn('name', '대표자', 'left', 100, false, false, false, 'text', {
      maxWidth: 100,
    }),
    CreateColumn('coId', 'ID', 'left', 100, false, false, false, 'text', {
      maxWidth: 100,
    }),
    CreateColumn('address1', '주소', 'left', 200, false, false, false, 'text', {
      minWidth: 200,
    }),
    CreateColumn(
      'address2',
      '상세주소',
      'left',
      200,
      false,
      false,
      false,
      'text',
      {
        minWidth: 200,
      }
    ),
    CreateColumn('coCd', '회사코드', 'left', 100, false, false, false, 'text', {
      minWidth: 100,
    }),
    CreateColumn(
      'monthlyContractFee',
      '계약금(월)',
      'right',
      120,
      false,
      false,
      false,
      'text',
      {
        maxWidth: 120,
        valueFormatter: (params) =>
          params.value !== '' &&
          params.value !== null &&
          params.value !== undefined
            ? String(params.value)
            : '',
      }
    ),
    CreateColumn(
      'paymentDay',
      '결제일(매월)',
      'center',
      120,
      false,
      false,
      false,
      'text',
      {
        maxWidth: 120,
        valueFormatter: (params) => {
          const v = params.value;
          if (v === '' || v === null || v === undefined) return '';
          const n = Number(v);
          if (!Number.isFinite(n)) return String(v);
          return `매월 ${n}일`;
        },
      }
    ),
    CreateColumn(
      'contractStartDate',
      '계약시작일자',
      'center',
      150,
      false,
      false,
      false,
      'date',
      {
        maxWidth: 150,
        valueFormatter: (params) =>
          params.value ? dayjs(params.value).format('YYYY-MM-DD') : '',
      }
    ),
    CreateColumn(
      'contractEndDate',
      '계약종료일자',
      'center',
      150,
      false,
      false,
      false,
      'date',
      {
        maxWidth: 150,
        valueFormatter: (params) =>
          params.value ? dayjs(params.value).format('YYYY-MM-DD') : '',
      }
    ),
    CreateColumn(
      'contractMemberCount',
      '총계약인원수',
      'right',
      150,
      false,
      false,
      false,
      'text',
      { maxWidth: 150 }
    ),
  ];
};

/**
 * 대표자 목록(모달) 그리드 컬럼 정의
 * @param {object} [opts]
 * @param {object} [opts.cellStyle] - 공통 셀 스타일(말줄임 등)
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs2 = (opts = {}) => {
  const { cellStyle: sharedCellStyle } = opts;
  const cellStyle = (base) =>
    sharedCellStyle ? { ...base, ...sharedCellStyle } : base;

  return [
    {
      checkboxSelection: true,
      field: 'no',
      headerName: 'NO',
      maxWidth: 80,
      cellStyle: cellStyle({ textAlign: 'right' }),
      editable: false,
    },
    {
      field: 'coId',
      headerName: 'ID',
      minWidth: 100,
      flex: 1,
      cellStyle: cellStyle({ textAlign: 'left' }),
    },
    {
      field: 'name',
      headerName: '이름',
      minWidth: 100,
      flex: 1,
      cellStyle: cellStyle({ textAlign: 'left' }),
    },
    {
      field: 'tel',
      headerName: '전화번호',
      minWidth: 110,
      flex: 1,
      cellStyle: cellStyle({ textAlign: 'left' }),
    },
    {
      field: 'birth',
      headerName: '생년월일',
      minWidth: 110,
      flex: 1,
      cellStyle: cellStyle({ textAlign: 'center' }),
      valueFormatter: (params) => {
        const v = params.value;
        if (v == null || v === '') return '';
        if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) return v;
        const d = dayjs(v);
        return d.isValid() ? d.format('YYYY-MM-DD') : String(v);
      },
    },
  ];
};
